import { defineFcm } from '../shared/factory';

export const FCM_SUNRISE_LOGIN_V3 = defineFcm('sunrise_login_v3').asBoolean().withDefault(false).toConfig();
